import React, { useState } from 'react';
import styles from './FeedbackModal.module.css';
import axios from '../../../api/axiosInstance'; // or fix the relative path if needed

const FeedbackModal = ({ isOpen, onClose }) => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const message = e.target.elements.feedback.value.trim();

    if (!message) {
      setError('Please enter a message.');
      return;
    }

    try {
      await axios.post('/api/feedback', {
        type: 'Comment',  // Default for now (until you add a dropdown)
        subject: '',      // Optional
        message,
      });
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        onClose();
      }, 1500);
    } catch (err) {
      console.error('❌ Error submitting feedback:', err);
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {success ? (
          <div className={styles.success}>✅ Thanks for your feedback!</div>
        ) : (
          <>
            <h2 className={styles.title}>We’d love your feedback!</h2>
            <form onSubmit={handleSubmit}>
              <textarea
                name="feedback"
                placeholder="What would you like to tell us?"
                className={styles.textarea}
                required
              />
              {error && <div className={styles.error}>{error}</div>}
              <div className={styles.actions}>
                <button type="button" className={styles.cancel} onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className={styles.submit}>
                  Submit
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default FeedbackModal;
